import React, { useRef, useState } from "react";
import PersonInMobileIcon from "../../../../../../assets/Images/TestImg/SchoolImg.png";
import SignatureImg from "../../../../../../assets/Images/TestImg/Signature.png";
import html2pdf from "html2pdf.js";
import ModalHistoryCard from "./ModalHistoryCard.component";
const DownloadExamReport = () => {
  const downloadPageRef = useRef(null);
  const [printStart, setPrintStart] = useState(false);
  const downloadReport = () => {
    if (!downloadPageRef) return;
    var opt = {
      margin: [0, 0],
      filename: "myfile.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
    };
    setPrintStart(true);
    html2pdf()
      .from(downloadPageRef.current)
      .set(opt)
      .save()
      .then(() => {
        setPrintStart(false);
      });
  };
  return (
    <div className="w-full pt-2 p-2 flex-col align-center justify-start g-2">
      <div className="w-full flex-row align-center justify-end">
        <button className="actionBtn" onClick={downloadReport}>
          Download
        </button>
      </div>
      <hr className="w-full border-grayColor" />
      <div
        ref={downloadPageRef}
        className="flex-col align-center justify-start g-05 p-1"
        style={{ width: "48rem" }}
      >
        <div className="flex-col align-center justify-start g-1">
          <img src={PersonInMobileIcon} alt="" style={{ width: "5rem" }} />
          <h3 className="t-24 poppins">
            Elementary School of Business and Social Sciences
          </h3>
        </div>
        <h3 className="t-20 color-grayColor poppins weight-500">
          Exam routines for class 8
        </h3>
        <hr className="w-full" color="#e5e5e5" />

        <table id="examHistoryTable">
          <thead>
            <tr>
              <th style={{ paddingBottom: "0.5rem" }}>Exam Name</th>
              <th style={{ paddingBottom: "0.5rem" }}>Venue</th>
              <th style={{ paddingBottom: "0.5rem" }}>Participating classes</th>
              <th style={{ paddingBottom: "0.5rem" }}>Conduct by</th>
              <th style={{ paddingBottom: "0.5rem" }}>Exam Status</th>
            </tr>
          </thead>
          <tbody>
            <ModalHistoryCard
              title="First Terminal Examination"
              description="27 Dec, 2024 - 07 Jan, 2025"
              venue="ABC boys class building"
              participatingClasses="All Classes"
              orderedBy="Authority"
              status="Completed"
            />
          </tbody>
        </table>

        <div className="w-full flex-col align-start justify-start g-1">
          {!printStart && (
            <h3 className="t-18 pppins color-grayColor">Class 8: </h3>
          )}

          <table id="examRoutingTable">
            <thead>
              <tr>
                <th>Subject name</th>
                <th>Subject code</th>
                <th>Time</th>
                <th>Exam date </th>
                <th>Room</th>
                <th>Invigilator</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
                <td>10:30 AM - 01: 30 PM</td>
                <td>09 October, 2024</td>
                <td>4D, 2n floor</td>
                <td>Samir Rahaman</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
                <td>10:30 AM - 01: 30 PM</td>
                <td>09 October, 2024</td>
                <td>4D, 2n floor</td>
                <td>Samir Rahaman</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
                <td>10:30 AM - 01: 30 PM</td>
                <td>09 October, 2024</td>
                <td>4D, 2n floor</td>
                <td>Samir Rahaman</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
                <td>10:30 AM - 01: 30 PM</td>
                <td>09 October, 2024</td>
                <td>4D, 2n floor</td>
                <td>Samir Rahaman</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
                <td>10:30 AM - 01: 30 PM</td>
                <td>09 October, 2024</td>
                <td>4D, 2n floor</td>
                <td>Samir Rahaman</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
                <td>10:30 AM - 01: 30 PM</td>
                <td>09 October, 2024</td>
                <td>4D, 2n floor</td>
                <td>Samir Rahaman</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
                <td>10:30 AM - 01: 30 PM</td>
                <td>09 October, 2024</td>
                <td>4D, 2n floor</td>
                <td>Samir Rahaman</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
                <td>10:30 AM - 01: 30 PM</td>
                <td>09 October, 2024</td>
                <td>4D, 2n floor</td>
                <td>Samir Rahaman</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="w-full flex-col align-start justify-start g-1">
          <p className="t-14 poppins">Date: 02 Oct, 2024</p>
          <div className="flex-row align-center justify-between">
            <div className="flex-col align-start justify-start g-1">
              <h3 className="t-16 poppins">
                Elementary School of Business and Social Sciences
              </h3>
              <address className="t-15 poppins" style={{ width: "50%" }}>
                15, Grand Trunk Rd, Deshbandhu Park, Uttarpara, Kolkata, West
                Bengal 700134
              </address>
            </div>

            <div className="flex-col align-center justify-center g-05">
              <img src={SignatureImg} alt="" style={{ height: "4rem" }} />
              <hr className="w-full" />
              <p className="t-14 pippins text-align-center">
                Authorized Signatory (Academic head)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadExamReport;
